var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-bottom-navigation",
    {
      attrs: {
        role: "navigation",
        "aria-label": _vm.$t("components.menu.landmarkLabel"),
        height: _vm.isLoggingOut ? "70" : "60",
        app: "",
        color: "primary",
      },
    },
    [
      _c(
        "v-flex",
        { attrs: { column: "" } },
        [
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoggingOut,
                expression: "isLoggingOut",
              },
            ],
            staticStyle: { margin: "0" },
            attrs: {
              color: "accent",
              indeterminate: "",
              "aria-live": "polite",
              "aria-label": "Logging out",
            },
          }),
          _vm._v(" "),
          _c(
            "v-sheet",
            { attrs: { elevation: "2" } },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "main-menu",
                  attrs: {
                    "show-arrows": "",
                    "icons-and-text": "",
                    centered: "",
                    "fixed-tabs": "",
                    "next-icon": "fad fa-chevron-right",
                    "prev-icon": "fad fa-chevron-left",
                    "slider-color": "accent",
                    color: "accent",
                    role: "tablist",
                    "aria-label": "Main Menu",
                  },
                },
                [
                  _c(
                    "v-tab",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLogged,
                          expression: "isLogged",
                        },
                      ],
                      key: "logout",
                      attrs: { role: "tab", text: "", "aria-selected": false },
                      on: {
                        click: function ($event) {
                          return _vm.onLogout()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("components.menu.logout")) +
                          "\n          "
                      ),
                      _c(
                        "v-icon",
                        { attrs: { small: "", "aria-hidden": "true" } },
                        [_vm._v("\n            fal fa-sign-out\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.downloadGames.length && _vm.$vuetify.breakpoint.mdAndUp
                    ? _c(
                        "v-menu",
                        {
                          attrs: { top: "", "open-on-hover": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "font-weight-medium text-body-2 text-uppercase",
                                            attrs: {
                                              "aria-label": "Download",
                                              text: "",
                                              "aria-haspopup": true,
                                              "aria-expanded":
                                                _vm.downloadMenuOpen,
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "components.menu.downloads"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mb-2",
                                            attrs: {
                                              small: "",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                fal fa-cloud-download\n              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1575165327
                          ),
                          model: {
                            value: _vm.downloadMenuOpen,
                            callback: function ($$v) {
                              _vm.downloadMenuOpen = $$v
                            },
                            expression: "downloadMenuOpen",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { role: "menu" } },
                            _vm._l(_vm.downloadGames, function (game) {
                              return _c(
                                "v-list-item",
                                {
                                  key: "dl-" + game.id,
                                  attrs: {
                                    role: "menuitem",
                                    tabindex: "0",
                                    link: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goTo(game.link)
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.goTo(game.link)
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.goTo(game.link)
                                      },
                                    ],
                                  },
                                },
                                [
                                  game.useImageAsBackground
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-list-item-background-image",
                                          style:
                                            "background-image: url('" +
                                            game.img +
                                            "')",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "v-list-item-download-labels",
                                            },
                                            [
                                              game.isNew
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "downloadLabel downloadNew",
                                                    },
                                                    [_vm._v("New")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              game.isRecommend
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "downloadLabel downloadRecommend",
                                                    },
                                                    [_vm._v("Recommend")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              game.isRecommend
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "downloadLabel downloadComingSoon",
                                                    },
                                                    [_vm._v("Coming Soon")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : [
                                        _c(
                                          "v-list-item-avatar",
                                          { attrs: { size: "25" } },
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(game.icon)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-no-wrap" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t(game.title)) +
                                                "\n                  "
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-list-item-download-labels",
                                              },
                                              [
                                                game.isNew
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "downloadLabel downloadNew",
                                                      },
                                                      [_vm._v("New")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                game.isRecommend
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "downloadLabel downloadRecommend",
                                                      },
                                                      [_vm._v("Recommend")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                game.isRecommend
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "downloadLabel downloadComingSoon",
                                                      },
                                                      [_vm._v("Coming Soon")]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("system-requirements"),
                  _vm._v(" "),
                  _vm._l(_vm.links, function (link) {
                    return _c(
                      "v-tab",
                      {
                        key: link.id,
                        attrs: {
                          role: "tab",
                          flat: "",
                          "aria-selected": false,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goToDynamic(link)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(link.text)) +
                            "\n          "
                        ),
                        _c(
                          "v-icon",
                          { attrs: { small: "", "aria-hidden": "true" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(link.icon) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.chapters.length
                    ? _c(
                        "v-menu",
                        {
                          attrs: { top: "", "open-on-hover": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "main-menu-button font-weight-medium text-body-2",
                                            attrs: {
                                              "aria-label": "Chapters",
                                              text: "",
                                              "aria-haspopup": true,
                                              "aria-expanded":
                                                _vm.chaptersMenuOpen,
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("components.menu.chapters")
                                            ) +
                                            "\n              "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mb-2",
                                            attrs: {
                                              small: "",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                fal fa-layer-plus\n              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3736981270
                          ),
                          model: {
                            value: _vm.chaptersMenuOpen,
                            callback: function ($$v) {
                              _vm.chaptersMenuOpen = $$v
                            },
                            expression: "chaptersMenuOpen",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { role: "menu" } },
                            _vm._l(_vm.chapters, function (chapter) {
                              return _c(
                                "v-list-item",
                                {
                                  key: "ch-" + chapter.id,
                                  attrs: { role: "menuitem", tabindex: "0" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goTo(chapter.link)
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.goTo(chapter.link)
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.goTo(chapter.link)
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    { attrs: { size: "25" } },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: chapter.img,
                                          alt: _vm.$t(chapter.title),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(chapter.title)
                                      ),
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.langs.length
                    ? _c(
                        "v-menu",
                        {
                          attrs: { flat: "", top: "", "open-on-hover": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "main-menu-button font-weight-medium text-body-2",
                                            attrs: {
                                              "aria-label": "Languages",
                                              text: "",
                                              "aria-haspopup": true,
                                              "aria-expanded":
                                                _vm.languagesMenuOpen,
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "components.menu.languages"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mb-2",
                                            attrs: {
                                              small: "",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                fal fa-language\n              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4142689595
                          ),
                          model: {
                            value: _vm.languagesMenuOpen,
                            callback: function ($$v) {
                              _vm.languagesMenuOpen = $$v
                            },
                            expression: "languagesMenuOpen",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { role: "menu" } },
                            _vm._l(_vm.langs, function (lang) {
                              return _c(
                                "v-list-item",
                                {
                                  key: lang.id,
                                  class:
                                    lang.code == _vm.currentLang
                                      ? "accent--text"
                                      : "whitesmoke--text",
                                  attrs: { role: "menuitem", tabindex: "0" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onLangUpdate(lang.code)
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.onLangUpdate(lang.code)
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.onLangUpdate(lang.code)
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    { attrs: { size: "25" } },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: lang.img,
                                          alt: lang.name,
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(lang.name),
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCompletedOAuth
                    ? _c(
                        "v-tab",
                        {
                          attrs: {
                            role: "tab",
                            "aria-selected": false,
                            to: _vm.toAbout(),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("components.menu.about")) +
                              "\n          "
                          ),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: "grey darken-1",
                                "aria-hidden": "true",
                              },
                            },
                            [_vm._v("\n            fal fa-info\n          ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCompletedOAuth
                    ? _c(
                        "v-tab",
                        {
                          attrs: {
                            role: "tab",
                            "aria-selected": false,
                            to: _vm.toFAQ(),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("components.menu.faq")) +
                              "\n          "
                          ),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                "aria-hidden": "true",
                                color: "grey darken-1",
                              },
                            },
                            [
                              _vm._v(
                                "\n            fad fa-question\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCompletedOAuth
                    ? _c(
                        "v-tab",
                        {
                          attrs: {
                            role: "tab",
                            "aria-selected": false,
                            to: _vm.toTc(),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("components.menu.tc")) +
                              "\n          "
                          ),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                "aria-hidden": "true",
                                color: "grey darken-1",
                              },
                            },
                            [
                              _vm._v(
                                "\n            fal fa-balance-scale\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }